import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const CreateFormatPage = () => (
  <TitleEntityForm
    create={apiRequests.events.createFormat}
    backTo="/events/formats"
    placeholder="Например, Онлайн"
    createdText="Формат создан"
  />
);

export default CreateFormatPage;
